import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { TextFormat, Translate, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './grid-operator-capacity-tariff.reducer';

export const GridOperatorCapacityTariff = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(
    overrideSortStateWithQueryParams(getSortState(pageLocation, 'id'), pageLocation.search),
  );

  const gridOperatorCapacityTariffList = useAppSelector(state => state.gridOperatorCapacityTariff.entities);
  const loading = useAppSelector(state => state.gridOperatorCapacityTariff.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      }),
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="grid-operator-capacity-tariff-heading" data-cy="GridOperatorCapacityTariffHeading">
        <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.home.title">
          Grid Operator Capacity Tariffs
        </Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.home.refreshListLabel">
              Refresh List
            </Translate>
          </Button>
          <Link
            to="/grid-operator-capacity-tariff/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.home.createLabel">
              Create new Grid Operator Capacity Tariff
            </Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {gridOperatorCapacityTariffList && gridOperatorCapacityTariffList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('tariff')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.tariff">Tariff</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('tariff')} />
                </th>
                <th className="hand" onClick={sort('effectiveDate')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.effectiveDate">
                    Effective Date
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('effectiveDate')} />
                </th>
                <th className="hand" onClick={sort('expirationDate')}>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.expirationDate">
                    Expiration Date
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('expirationDate')} />
                </th>
                <th>
                  <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.gridOperatorCapacity">
                    Grid Operator Capacity
                  </Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {gridOperatorCapacityTariffList.map((gridOperatorCapacityTariff, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button
                      tag={Link}
                      to={`/grid-operator-capacity-tariff/${gridOperatorCapacityTariff.id}`}
                      color="link"
                      size="sm"
                    >
                      {gridOperatorCapacityTariff.id}
                    </Button>
                  </td>
                  <td>{gridOperatorCapacityTariff.tariff}</td>
                  <td>
                    {gridOperatorCapacityTariff.effectiveDate ? (
                      <TextFormat
                        type="date"
                        value={gridOperatorCapacityTariff.effectiveDate}
                        format={APP_LOCAL_DATE_FORMAT}
                      />
                    ) : null}
                  </td>
                  <td>
                    {gridOperatorCapacityTariff.expirationDate ? (
                      <TextFormat
                        type="date"
                        value={gridOperatorCapacityTariff.expirationDate}
                        format={APP_LOCAL_DATE_FORMAT}
                      />
                    ) : null}
                  </td>
                  <td>
                    {gridOperatorCapacityTariff.gridOperatorCapacity ? (
                      <Link to={`/grid-operator-capacity/${gridOperatorCapacityTariff.gridOperatorCapacity.id}`}>
                        {gridOperatorCapacityTariff.gridOperatorCapacity.capacityCode}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/grid-operator-capacity-tariff/${gridOperatorCapacityTariff.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/grid-operator-capacity-tariff/${gridOperatorCapacityTariff.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/grid-operator-capacity-tariff/${gridOperatorCapacityTariff.id}/delete`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="crawlerBackendApp.gridOperatorCapacityTariff.home.notFound">
                No Grid Operator Capacity Tariffs found
              </Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default GridOperatorCapacityTariff;
